import React from 'react';
import Modal from 'components/shared/Modal/Modal';
import classnames from 'classnames';
import { BUTTON_LOADING_CIRCLE } from 'common/utils/constants';
import './ManageColumnsModal.css';

const ManageColumnsModalErrorBox = (props) => {
  return (
    <Modal animateX={false} close={() => props.onClose()} noPadding height={266} width={480}>
      <div className="ManageColumnsModalErrorBox_Container">
        <div className="ManageColumnsModalErrorBox_TopContainer">
          <div className={'ManageColumnsModalErrorBox_HeaderText'} data-tip={props.title}>
            {props.title}
          </div>
          <div className="ManageColumnsModalErrorBox_MessageText" data-tip={props.message}>
            {props.message}
          </div>
        </div>
        <div className="ManageColumnsModalErrorBox_BottomContainer">
          <button
            className="ManageColumnsModalErrorBox_Bottom_CancelButton"
            onClick={() => {
              props.onClose();
            }}
          >
            Close
          </button>
          {/* {props.action && (
            <button
              type="submit"
              disabled={props.isFetching && props.isFetching}
              className={classnames({
                ManageColumnsModalErrorBox_Bottom_ActionButton: true
                // ManageColumnsModalErrorBox_Bottom_ActionButton_Disabled: nameInputError !== '' || deviceIdsValid()
              })}
              onClick={() => {
                props.action();
              }}
            >
              {props.isFetching ? BUTTON_LOADING_CIRCLE : 'Retry'}
            </button>
          )} */}
        </div>
      </div>
    </Modal>
  );
};

export default ManageColumnsModalErrorBox;
